<button
    type="button"
    class="anc-chip"
    [class.anc-chip--size-default]="size === 'default'"
    [class.anc-chip--size-compact]="size === 'compact'"
    [class.anc-chip--selected]="selected"
    [class.anc-chip--disabled]="disabled"
    [disabled]="disabled"
    [attr.aria-label]="ariaLabel || label"
    [attr.aria-pressed]="selected"
    (click)="onClick()"
>
    <span *ngIf="leadingIcon" class="anc-chip__icon icon {{ leadingIcon }}" aria-hidden="true"></span>
    <span class="anc-chip__label">{{ label }}</span>
    <span
        *ngIf="removable"
        class="anc-chip__remove icon icon-x"
        role="button"
        [attr.aria-label]="'Remove ' + (ariaLabel || label)"
        (click)="onRemoveClick($event)"
    ></span>
</button>
